var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGraphView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M15 5.5C15 4.67157 14.3284 4 13.5 4C12.6716 4 12 4.67157 12 5.5V15.5C12 16.3284 12.6716 17 13.5 17C14.3284 17 15 16.3284 15 15.5V5.5Z",
    fill: "#8F8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10 10.5C10 9.67157 9.32843 9 8.5 9C7.67157 9 7 9.67157 7 10.5V15.5C7 16.3284 7.67157 17 8.5 17C9.32843 17 10 16.3284 10 15.5V10.5Z",
    fill: "#8F8F8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19H20C20.55 19 21 19.44 21 20C21 20.55 20.55 21 20 21H4C3.44 21 3 20.55 3 20V4C3 3.44 3.44 3 4 3C4.55 3 5 3.44 5 4V19Z",
    fill: "#8F8F8F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M20 12.5C20 11.6716 19.3284 11 18.5 11C17.6716 11 17 11.6716 17 12.5V15.5C17 16.3284 17.6716 17 18.5 17C19.3284 17 20 16.3284 20 15.5V12.5Z",
    fill: "#8F8F8F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphView);
export default __webpack_public_path__ + "static/media/graph-view.2afd6a48.svg";
export { ForwardRef as ReactComponent };